export default __webpack_public_path__ + "static/media/mobile-bg.d1535d01.webp";